import IconButton from "@mui/material/IconButton";
import React from "react";
import PropTypes from "prop-types";
import merge from "lodash/merge";
import classNames from "classnames";
import { styled } from "@material-ui/styles";
import TooltipBasic from "../tooltip/TooltipBasic";

const commonProps = {
  width: "40px",
  height: "40px",
  padding: "auto",
};

const styleInActive = {
  "&.MuiIconButton-root": {
    backgroundColor: "",
    // boxShadow: "",
  },
};

const styleActive = {
  "&.MuiIconButton-root": {
    backgroundColor: "rgba(59, 191, 240, 0.1)",
    // boxShadow: "0 8px 16px 0 rgba(59, 191, 240, 0.16)",
  },
};

const squareStyle = {
  "&.MuiIconButton-root": {
    ...commonProps,
    borderRadius: "8px",
  },
};

const circleStyle = {
  "&.MuiIconButton-root": {
    ...commonProps,
  },
};

const IconButtonGen = (props) => {
  const {
    sx,
    className,
    variant,
    disabled,
    onClick,
    iconSrc,
    iconActiveSrc,
    iconWidth,
    iconAlt,
    active,
    toolTipTitle,
    tooltipPlacement,
  } = props;

  const mergeStyle = () =>
    merge(
      variant === "square" ? squareStyle : circleStyle,
      (active && styleActive) || styleInActive,
      sx || {}
    );

  const iconButtonEle = (
    <IconButton
      className={classNames("dao-iconButton", className)}
      sx={mergeStyle()}
      onClick={onClick}
      disabled={disabled}
    >
      {(iconSrc || iconActiveSrc) && (
        <img
          src={active ? iconActiveSrc || iconSrc : iconSrc}
          alt={iconAlt}
          width={iconWidth}
        />
      )}
    </IconButton>
  );

  return (
    (toolTipTitle && (
      <TooltipBasic
        tooltipProps={{
          title: toolTipTitle,
          placement: tooltipPlacement,
        }}
      >
        <span>{iconButtonEle}</span>
      </TooltipBasic>
    )) || <span>{iconButtonEle}</span>
  );
};

IconButtonGen.propTypes = {
  /** 樣式 */
  sx: PropTypes.objectOf(PropTypes.any),
  /** Css Name */
  className: PropTypes.string,
  /** 樣式 */
  variant: PropTypes.oneOf(["square", "circle"]),
  /** 是否 disabled button */
  disabled: PropTypes.bool,
  /** click callback */
  onClick: PropTypes.func,
  /** icon src(non-active) */
  iconSrc: PropTypes.string,
  /** icon src(active) */
  iconActiveSrc: PropTypes.string,
  /** icon 是否 active(會影響使用 iconSrc  iconActiveSrc) */
  active: PropTypes.bool,
  /** icon image width */
  iconWidth: PropTypes.number,
  /** icon img alt */
  iconAlt: PropTypes.string,
  /** tooltip title */
  toolTipTitle: PropTypes.string,
  /** tooltip placement */
  tooltipPlacement: PropTypes.oneOf([
    "bottom-end",
    "bottom-start",
    "bottom",
    "left-end",
    "left-start",
    "left",
    "right-end",
    "right-start",
    "right",
    "top-end",
    "top-start",
    "top",
  ]),
};

IconButtonGen.defaultProps = {
  sx: undefined,
  className: undefined,
  variant: "square",
  disabled: false,
  onClick: () => null,
  iconSrc: undefined,
  iconActiveSrc: undefined,
  iconWidth: 24,
  active: false,
  iconAlt: "",
  toolTipTitle: "",
  tooltipPlacement: "right",
};

export default IconButtonGen;
